import { MinimalPoolStore } from "@/domains/minimal-pool/minimal-pool-store"

export const filterMinimalPools = (
  pool: MinimalPoolStore,
  search: string,
  nativeTokenSymbol: string,
  wrappedNativeSymbol: string,
): boolean => {
  if (!search || search === "") {
    return true
  }

  const searchLower = search.toLowerCase()
  const nativeTokenSymbolLower = nativeTokenSymbol.toLowerCase()
  const wrappedNativeSymbolLower = wrappedNativeSymbol.toLowerCase()

  // If they are searching EXACTLY for the native token symbol
  // we shift the search as IF it is the wrapped native token
  if (nativeTokenSymbolLower === searchLower) {
    return (
      pool.token0.symbol.toLowerCase() === wrappedNativeSymbolLower ||
      pool.token1.symbol.toLowerCase() === wrappedNativeSymbolLower
    )
  }

  if (wrappedNativeSymbolLower === searchLower) {
    // we only search for specific things in this mode.
    // token0 or token1 MUST match the native token symbol
    return (
      pool.token0.symbol.toLowerCase() === wrappedNativeSymbolLower ||
      pool.token1.symbol.toLowerCase() === wrappedNativeSymbolLower
    )
  }

  if (
    pool.address.toString().toLowerCase().includes(searchLower) ||
    pool.token0.symbol.toLowerCase().includes(searchLower) ||
    pool.token0.address.toString().toLowerCase().includes(searchLower) ||
    pool.token1.symbol.toLowerCase().includes(searchLower) ||
    pool.token1.address.toString().toLowerCase().includes(searchLower) ||
    pool.displayName?.toLowerCase().includes(searchLower) ||
    pool.displayType?.toLowerCase().includes(searchLower) ||
    pool.extendedType?.toLowerCase().includes(searchLower)
  ) {
    return true
  }

  return false
}

